export const hasValue = (value) =>
  value !== '' && value !== null && value !== undefined;
export const enumLabel = (labels, value) =>
  Array.isArray(labels) && hasValue(value) ? labels[value] ?? '' : '';
